// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: -moz-fit-content;
  height: fit-content;
}

ion-content.popup-content {
  --background: transparent;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  overflow: hidden !important;
}

.confirm-card {
  width: 100%;
  padding: 24px 20px;
  background: #fff;
  border: 1px solid #e4ece7;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(15, 110, 86, 0.1);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  word-wrap: break-word;
  overflow: hidden !important;
}

.confirm-card h2 {
  margin: 0 0 8px 0;
  font-size: 17px;
  font-weight: 700;
  color: #1f2f26;
  line-height: 1.2;
}

.confirm-card p {
  margin: 0 0 16px 0;
  color: #6f8377;
  font-size: 13px;
  line-height: 1.3;
}

.confirm-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  width: 100%;
}

.confirm-primary,
.confirm-secondary {
  margin: 0;
  height: 44px;
  --border-radius: 4px;
  text-transform: none;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  padding: 0 4px;
  min-width: 0;
}

.confirm-primary {
  --background: #2E7D32;
  --background-activated: #0d5a47;
  --opacity-activated: 0.9;
  --color: #fff;
}

.confirm-secondary {
  --background: #e6f5ef;
  --background-activated: #d6ede5;
  --color: #2E7D32;
}`, "",{"version":3,"sources":["webpack://./src/app/custom popup/reservationPreSelectMenuPopup/reservationPreSelectMenuPopup.scss","webpack://./src/app/custom%20popup/reservationPreSelectMenuPopup/reservationPreSelectMenuPopup.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,wBAAA;EAAA,mBAAA;ACCF;;ADEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EAAqB,kBAAA;EAErB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,WAAA;EACA,2BAAA;ACCF;;ADEA;EACE,WAAA;EACD,kBAAA;EACC,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;ACCF;;ADEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;ACCF;;ADEA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ACCF;;ADEA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;ACCF;;ADEA;;EAEE,SAAA;EACA,YAAA;EACA,oBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;ACCF;;ADEA;EACE,qBAAA;EACA,+BAAA;EACA,wBAAA;EACA,aAAA;ACCF;;ADEA;EACE,qBAAA;EACA,+BAAA;EACA,gBAAA;ACCF","sourcesContent":[":host {\r\n  display: block;\r\n  height: fit-content;\r\n}\r\n\r\nion-content.popup-content {\r\n  --background: transparent;\r\n  --padding-start: 0;\r\n  --padding-end: 0;\r\n  --padding-top: 0;\r\n  --padding-bottom: 0; --overflow: hidden;\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: fit-content;\r\n  width: 100%;\r\n  overflow: hidden !important;\r\n}\r\n\r\n.confirm-card {\r\n  width: 100%;\r\n padding: 24px 20px;\r\n  background: #fff;\r\n  border: 1px solid #e4ece7;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 10px rgba(15, 110, 86, 0.1);\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  word-wrap: break-word;\r\n  overflow: hidden !important;\r\n}\r\n\r\n.confirm-card h2 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  color: #1f2f26;\r\n  line-height: 1.2;\r\n}\r\n\r\n.confirm-card p {\r\n  margin: 0 0 16px 0;\r\n  color: #6f8377;\r\n  font-size: 13px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.confirm-actions {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 10px;\r\n  width: 100%;\r\n}\r\n\r\n.confirm-primary,\r\n.confirm-secondary {\r\n  margin: 0;\r\n  height: 44px;\r\n  --border-radius: 4px;\r\n  text-transform: none;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  padding: 0 4px;\r\n  min-width: 0;\r\n}\r\n\r\n.confirm-primary {\r\n  --background: #2E7D32;\r\n  --background-activated: #0d5a47;\r\n  --opacity-activated: 0.9;\r\n  --color: #fff;\r\n}\r\n\r\n.confirm-secondary {\r\n  --background: #e6f5ef;\r\n  --background-activated: #d6ede5;\r\n  --color: #2E7D32;\r\n}",":host {\n  display: block;\n  height: fit-content;\n}\n\nion-content.popup-content {\n  --background: transparent;\n  --padding-start: 0;\n  --padding-end: 0;\n  --padding-top: 0;\n  --padding-bottom: 0;\n  --overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: fit-content;\n  width: 100%;\n  overflow: hidden !important;\n}\n\n.confirm-card {\n  width: 100%;\n  padding: 24px 20px;\n  background: #fff;\n  border: 1px solid #e4ece7;\n  border-radius: 8px;\n  box-shadow: 0 4px 10px rgba(15, 110, 86, 0.1);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  word-wrap: break-word;\n  overflow: hidden !important;\n}\n\n.confirm-card h2 {\n  margin: 0 0 8px 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: #1f2f26;\n  line-height: 1.2;\n}\n\n.confirm-card p {\n  margin: 0 0 16px 0;\n  color: #6f8377;\n  font-size: 13px;\n  line-height: 1.3;\n}\n\n.confirm-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  width: 100%;\n}\n\n.confirm-primary,\n.confirm-secondary {\n  margin: 0;\n  height: 44px;\n  --border-radius: 4px;\n  text-transform: none;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  padding: 0 4px;\n  min-width: 0;\n}\n\n.confirm-primary {\n  --background: #2E7D32;\n  --background-activated: #0d5a47;\n  --opacity-activated: 0.9;\n  --color: #fff;\n}\n\n.confirm-secondary {\n  --background: #e6f5ef;\n  --background-activated: #d6ede5;\n  --color: #2E7D32;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
